import React, { Component } from 'react'
import PropTypes from 'prop-types';

// import Truncate from 'react-truncate';
import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fontSize, minScreenSize } from '../lib/theme';
// import Truncate from 'react-truncate';
import { colors, mainLayoutColor } from '../lib/theme';
const textVersion = require("textversionjs");

const styleConfig = {
    linkStyle: (href, linkText) => {
        return linkText + " " + "(" + href + ")";
    }
};
// var HtmlToReact = require('html-to-react');
// var HtmlToReactParser = HtmlToReact.Parser;
// var htmlToReactParser = new HtmlToReactParser();

// var isValidNode = function () {
//     return true;
// };
// Order matters. Instructions are processed in the order they're defined
// var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
// var processingInstructions = [
//     // {
//     //     // Custom <a> processing to open in new tab
//     //     shouldProcessNode: function (node) {
//     //         // return node.parent && node.parent.name && node.parent.name === 'h1';
//     //         if (node.attribs && node.attribs['target']) {
//     //             return true; // node.setAttribute('target','_blank');
//     //         }
//     //         // return false;
//     //     },
//     //     processNode: function (node, children) {
//     //         console.dir(node.attribs);
//     //         console.dir(node);
//     //         return node.data;
//     //         // return node.setAttribute('target', '_blank'); // node.data.toUpperCase();
//     //     }
//     // },
//     // {
//     //     // Custom <a> processing to open in new tab
//     //     shouldProcessNode: function (node) {
//     //         // return node.parent && node.parent.name && node.parent.name === 'h1';
//     //         // if (!node.hasAttribute('target') && (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
//     //         if (node.attribs && (!node.attribs['target'] && (node.attribs['xlink:href'] || node.attribs['href']))) {
//     //             return true;
//     //         }
//     //         // return false;
//     //     },
//     //     // eslint-disable-next-line react/display-name
//     //     processNode: function (node, children, index) {
//     //         console.dir(node.attribs);
//     //         console.dir(node);
//     //         var element = React.createElement('a', { key: index }, node.data);
//     //         return element; // .createElement('h1', {key: index,}, 'Heading');
//     //         // return node.attribs.target = '_blank'; // node.data.toUpperCase();
//     //         // return node.parent.setAttribute('xlink:show', 'new'); //node.setAttribute('target', '_blank'); // node.data.toUpperCase();
//     //         // return node.attribs['target'] = '_blank'; //node.setAttribute('target', '_blank'); // node.data.toUpperCase();
//     //     }
//     // },
//     {
//         // Anything else
//         shouldProcessNode: function (node) {
//             return true;
//         },
//         processNode: processNodeDefinitions.processDefaultNode,
//     }
// ];


// const setLimit = 300;
export default class ExpandCollapse extends Component {
    constructor(props) {
        super(props);
        const textInfo = props.textInfo;
        let textInfoNew = '';
        // console.dir(textInfo);
        if (typeof textInfo === 'string') {
            textInfoNew = textInfo.replace(/<br>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
                .replace(/&lt/g, '<').replace(/&gt/g, '>').replace(/&nbsp;/g, ''); /// need this for some podcasts like content champion
        }
        // console.dir(textInfoNew);
        const descriptionText = textVersion(textInfoNew, styleConfig);
        this.state = { description: '', descriptionText: descriptionText, textInfoNew: textInfoNew, expanded: false, setLimit: 3, limitLines: 'limit-lines' };
        if (props.parent === 'episode') {
            this.state.setLimit = 3;
        } else {
            this.state.setLimit = 5;
        }
        // this.myRef = React.createRef();
        // this.props.loadingUserDetailsState(true);
    }

    componentDidMount() {

        // const handleResize = () => {
        //     console.log('resized to: ', window.innerWidth, 'x', window.innerHeight);
        //     this.setState({});
        // }


        // window.addEventListener('resize', handleResize);

        DOMPurify.addHook('afterSanitizeAttributes', function (node) {
            // set all elements owning target to target=_blank
            if ('target' in node) {
                node.setAttribute('target', '_blank');
                // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
                node.setAttribute('rel', 'nofollow noopener');
            }
            // set non-HTML/MathML links to xlink:show=new
            if (!node.hasAttribute('target')
                && (node.hasAttribute('xlink:href')
                    || node.hasAttribute('href'))) {
                node.setAttribute('xlink:show', 'new');
            }
        });

        this.setDescription();
    }

    componentDidUpdate(prevProps) {
        const { textInfo } = this.props;
        if (textInfo !== prevProps.textInfo) {
            this.setDescription();
        }
    }

    // componentWillUnmount() {
    //     window.removeEventListener('resize');
    // }

    setDescription() {
        const { textInfo } = this.props;
        const { textInfoNew } = this.state;
        // let textInfoNew = '';
        // if (typeof textInfo === 'string') {
        //     textInfoNew = textInfo.replace(/<br>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        //         .replace(/&lt/g, '<').replace(/&gt/g, '>').replace(/&nbsp;/g, ''); /// need this for some podcasts like content champion
        // }
        // // console.dir(Date.now());
        // const descriptionText = textVersion(textInfoNew, styleConfig);
        // console.dir(Date.now());
        // const textInfoNew = textInfo.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"'); /// need this for some podcasts like content champion
        // this.setState({ description: DOMPurify.sanitize(textInfoNew || ''), descriptionText: textInfoNew.replace(/(<([^>]+)>)/g, "") });
        this.setState({ description: DOMPurify.sanitize(textInfoNew || '') });
        // console.dir(Date.now());
        this.collapse();
    }

    toggleExpand = () => {
        // const { textInfo } = this.props;
        const { expanded } = this.state;
        var selection = window.getSelection();
        if (!selection || !selection.toString()) {
            if (expanded) {
                this.collapse();
            } else {
                this.expand();
            }
        }
    }

    expand = () => {
        this.setState({ expanded: true, limitLines: '' });
    }

    collapse = () => {
        // const element = document.querySelectorAll('.clamp');
        // const element = this.myRef.current;
        // console.dir(element);
        // if (element) {
        // console.dir(element.innerHTML);
        // let result = $clamp(element, { clamp: 2 , useNativeClamp: false}); // $clamp is loaded as min.js in <Head />
        // console.dir(result);
        // console.dir(element.innerHTML);
        // let oldhtml = element.html;
        // let newhtml = oldhtml.replace('|...more', '<a  class="more-btn collapsed" data-  toggle="collapse" href="#" aria-expanded="false"   >...More</a>');
        // element.html(newhtml);
        this.setState({ expanded: false, limitLines: 'limit-lines' });
        // }
    }

    render() {
        const { parent, isCard } = this.props;
        // console.dir(isCard);
        // const { description, limitLines, parent } = this.state;
        const { description, descriptionText, limitLines } = this.state;
        // console.dir(description);
        // console.dir(descriptionText);
        return (
            <div className='main' style={{ width: (limitLines || isCard) ? 'auto' : '30vw' }}>
                {/* <p className={limitLines} onClick={this.toggleExpand} dangerouslySetInnerHTML={{ __html: description }}></p> */}
                {/* <p className={limitLines + ' ' + parent} onClick={this.toggleExpand} dangerouslySetInnerHTML={{ __html: description }}></p> */}
                {/* <div style={{ height: '1px', fontSize: '1px', color: `${mainLayoutColor}` }}>
                    {descriptionText}
                </div> */}
                {parent === 'episode' ?
                    <>
                        {limitLines ?
                            // <p ref={this.myRef} className='clamp'>{descriptionText}</p>
                            <div onClick={this.expand}>
                                {/* <Dotdotdot clamp={2} truncationChar={'&nbsp;'}
                                    truncationHTML={`<a>&hellip;Read more</a>`}
                                >
                                    {descriptionText}
                                </Dotdotdot> */}
                            </div>
                            :
                            <div className={limitLines + ' ' + parent} onClick={this.toggleExpand} dangerouslySetInnerHTML={{ __html: description }}></div>
                        }
                    </>
                    :
                    <>
                        {/* <div className='hide-media'>
                            {descriptionText}
                        </div> */}
                        <div className={`${parent}` + ' '} dangerouslySetInnerHTML={{ __html: description }}></div>
                    </>
                }
                {/* <div>{ReactHtmlParser(textInfo)}</div> */}
                {/* {parent === 'episode' ?
                    <div className={limitLines + ' ' + parent} onClick={this.toggleExpand}>{htmlToReactParser.parse(textInfo)}</div>
                    : <div className={parent}>{htmlToReactParser.parse(textInfo)}</div>
                } */}


                {/* {parent === 'episode' ?
                    <div className={limitLines + ' ' + parent} onClick={this.toggleExpand}>{htmlToReactParser.parseWithInstructions(textInfo, isValidNode,
                        processingInstructions)}</div>
                    : <div className={parent}>{htmlToReactParser.parseWithInstructions(textInfo, isValidNode,
                        processingInstructions)}</div>
                } */}

                {/* <p className='ellipsis'>&hellip;</p> */}
                <style jsx>
                    {`
                    .main {
                        // height: 88px;
                        // display: table;
                        max-height: ${!isCard ? '30vh' : '16vh'};
                        overflow: auto; // overlay;
                        color: #7b82a4; // #716f86; // #4e4c68;
                    }
                    .main > div {
                        width: 96%;
                        line-height: 1.75;
                    }
                    .limit-lines {
                        text-overflow: ellipsis;
                        line-height: 16px;     /* fallback */
                        max-height: calc(${this.state.setLimit} * 1.1em);      /* fallback */
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                    }
                    .more {
                        position: absolute;
                        right: 1.25em;
                        // top: 76px;
                        bottom: 10px;
                        background: hsla(228, 55%, 98%, 1);
                        padding-left: 1em;
                        color: blue;
                    }
                    .podcast {
                        -webkit-line-clamp: calc(${this.state.setLimit} - 2);
                    }
                    .episode {
                        cursor: pointer;
                        -webkit-line-clamp: calc(${this.state.setLimit} - 1);
                    }
                    :global(.podcast img) {
                        max-width: 120px;
                    }
                    :global(.podcast p, .episode span) {
                        font-size: 0.95rem !important;
                    }
                    :global(.episode p, .episode span) {
                        font-size: 0.85rem !important;
                    }
                    :global(.limit-lines.episode p) {
                        margin-bottom: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        // display: -webkit-box;
                        line-height: 1.75;     /* fallback */
                        max-height: calc(${this.state.setLimit} * 16px);      /* fallback */
                        -webkit-line-clamp: ${this.state.setLimit}; /* number of lines to show */
                        -webkit-box-orient: vertical;
                    }
                    :global(.podcast p) {
                        margin-bottom: 0;
                    }
                    @media ${minScreenSize.mobileS} {
                        .hide-media {
                          display: none;
                        }
                    }
                    
                    // .ellipsis {
                    //     display: inline;
                    //     position: absolute;
                    //     bottom: 0;
                    //     margin-bottom: 0.6em;
                    // }
                    `}
                </style>
            </div >
        )
    }
}
ExpandCollapse.defaultProps = {
    isCard: false
}
ExpandCollapse.propTypes = {
    textInfo: PropTypes.string,
    parent: PropTypes.string,
    isCard: PropTypes.bool,
}
